export const Work = () => {
  return (
    <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.5 13.5H8.50007C7.94779 13.5 7.50007 13.9477 7.50007 14.5V32C7.50007 32.5523 7.94779 33 8.50007 33H32.5C33.0523 33 33.5 32.5523 33.5 32V14.5C33.5 13.9477 33.0523 13.5 32.5 13.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8563 33V9.97143C25.8563 9.18336 25.5555 8.42756 25.0201 7.87031C24.4847 7.31306 23.7585 7 23.0014 7H18.0053C17.2481 7 16.522 7.31306 15.9866 7.87031C15.4512 8.42756 15.1504 9.18336 15.1504 9.97143V33"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
